import { FC } from 'react'
import { ColorOptions, FontSizeOptions } from '../../theme/UiThemeProvider'
import { Text } from '../Text'

export const IconIds = {
  HOME: '\ue902',
  LOGO: '\ue9fb',
  SEARCH: '\ue93a',
  SHARE: '\ue937',
  CLOSE: '\ue925',
  CLEAR: '\ue915',
  LOCATE: '\ue9e6',
  LOCATION: '\ue9fd',
  SOCIETY: '\uea23',
  HISTORY: '\ue90c',
  ARROW_UP: '\ue953',
  ARROW_DOWN: '\ue954',
  SUCCESSFUL_EMPTY: '\ue935',
  SUCCESSFUL_FILLED: '\ue934',
  TICKMARK: '\ue91d',
  RADIOBUTTON_ON: '\ue929',
  RADIOBUTTON_OFF: '\ue92a',
  CHECKBOX_OUTLINE: '\ue94e',
  CHECKBOX_UNCHECKED: '\ue94d',
  CHECKBOX_CHECKED: '\ue950',
  STATUS_SUCCESS: '\ue91d',
  STATUS_PENDING: '\ue942',
  STATUS_AWAITING: '\ue901',
  STATUS_FAILED: '\ue925',
  GOLD_SAVINGS_PLAN: '\ue975',
  BUY_GOLD: '\uea06',
  INCREMENT: '\uea11',
  DECREMENT: '\uea10',
  ARROW_BACK: '\ue921',
  ARROW_RIGHT: '\ue952',
  ARROW_LEFT: '\ue955',
  TIMER: '\ue901',
  FILTER: '\ue92c',
  FILTER2: '\ue9a2',
  FAQ: '\ue946',
  CART: '\ue98f',
  CART_FILLED: '\ue815',
  DOWNLOAD: '\ue947',
  CALENDAR: '\ue94f',
  LOCK: '\ue969',
  INFO: '\ue942',
  DEFAULT_CARD: '\ue94b',
  ICON_CLOSE: '\ue925',
  ICON_REFRESH: '\ue9b1',
  STAR_FILLED: '\ue99a',
  WALLET: '\ue940',
  STAR: '\ue99b',
  USER: '\ue92f',
  SORT: '\ue9f0',
  FAVOURITE: '\ue90f',
  FAVOURITE_FILLED: '\ue96e',
  LIST_SORT: '\ue9a5',
  LOCATION_MAP: '\ue963',
  EDIT: '\ue90b',
  MENU: '\ue917',
  RESTAURANT: '\ue9e9',
  WIFI: '\ue982',
  PARKING: '\ue9a9',
  CALL: '\uea0e',
  ROOM_SERVICE: '\ue9c9',
  SETTING: '\ue936',
  NEWBILLER: '\ue932',
  NOTIFICATION: '\ue92b',
  DELETE: '\ue949',
  STOP: '\ue9b0',
  ADD: '\ue959',
  OPTIONS: '\ue916',
  PAYLATER: '\ue93b',
  CONTACTS: '\ue99f',
  ADDBILLER: '\ue93d',
  BANK: '\ue95b',
  ROUND_TICK: '\ue935',
  ROUND_TICK_FILLED: '\ue934',
  SHOP: '\ue908',
  EXCLAMATION: '\ue948',
  EYE_WATCH: '\uE930',
  EYE_WATCH_SELECTED: '\ue927',
  THUMB_VIEW: '\ue9a1',
  LOAD_MONEY: '\ue971',
  LAYERS: '\ue95e',
  UPLOAD: '\ue928',
  FILTER3: '\ue9ae',
  ACCOUNT: '\ue95a',
  TRANSACTIONS: '\uE9D5',
  SETTLEMENTS: '\uE974',
  PLANS: '\uE986',
  REFUNDS: '\uE93B',
  INVOICES: '\uE9FE',
  CAMERA: '\uE923',
  SCAN_QR: '\ue95f',
  VIDEOS: '\ue9c2',
  SUPPORT: '\ue9b3',
  LOGOUT: '\ue90a',
  DUPLICATE: '\ue986',
  MOBILE: '\ue9ed',
  DTH: '\ue9b9',
  DATA_CARD: '\ue993',
  ELECTRICITY: '\ue980',
  CYLINDER: '\ue9aa',
  INSURANCE: '\ue9bb',
  LANDLINE: '\ue9ef',
  CHARITY: '\ue975',
  BROADBAND: '\ue989',
  WATER: '\ue9ff',
  HOUSING: '\uea23',
  MUNICIPAL_TAX: '\uea20',
  MUTUAL_FUND: '\ue809',
  JIO_PAYMENTS: '\ue9b6',
  TOLL: '\uea0d',
  FASTAG: '\uea0d',
  EDUCATION: '\ue9d2',
  GIFT_CARD: '\ue988',
  MAX_LIMIT: '\uea13',
  PAYMENT_LINKS: '\uEA22',
  INSIGHTS: '\uE90E',
  BULK_REFUND: '\uE9E5',
  JIO_ICON: '\ue9f5',
  HAMBURGER_MENU: '\ue93c',
  JIO_MONEY: '\ue9fb',
  EMAIL: '\ue97e',
  FINGERPRINT: '\ue943',
  CASH_WITHDRAWL: '\ue9d0',
  FUND_TRANSFER: '\uea13',
  CASH_DEPOSIT: '\ue971',
  BALANCE_ENQUIRY: '\ue951',
  MINI_STATEMENT: '\ue9fe',
  TNX_ENQUIRY: '\ue933',
  CARD_CVV: '\ue95c',
  EMI: '\ue9f4',
  MY_ACCOUNT: '\ue97a',
  CONTACT_US: '\ue938',
  TOKEN: '\ue973',
  ADD_USER: '\ue924',
  CUSTOMIZE: '\ue93e',
  SMILE: '\ue966',
  ARROWS: '\ue97c',
  MOBILE_CARD: '\ue945',
  TOKENIZED_CARD: '\ue9ca',
  BARCODE: '\uE912',
  BLOCK: '\ue9b0',
  UNBLOCK: '\ue9ac',
  HAMBURGER_OPTIONS: '\ue90D',
  VAULT: '\ue814',
  IMPORT: '\ue98a',
  FAST_TAG: '\uea2b',
  CHAT: '\ue926',
}

export type IconOptions = keyof typeof IconIds
export const IconIdsOptionArray = Object.keys(IconIds)

interface IconProps {
  id: IconOptions
  size?: FontSizeOptions | number
  color?: ColorOptions
  hide?: boolean
}

export const Icon: FC<IconProps> = ({ id, size = 'FONT_SIZE_MEDIUM', color = 'PRIMARY', hide = false }) => {
  if (hide) {
    return null
  }

  return (
    <Text fontSize={size} color={color} fontFamily="JioMoney">
      {IconIds[id]}
    </Text>
  )
}
